import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"
import SidebarContent from "./SidebarContent"
import logoSm from "../../assets/images/amos-small.png";
import logoLightPng from "../../assets/images/amos-light.png";
import logoDark from "../../assets/images/amos-dark.png";

const Sidebar = props => {
    const logoSubtitle = process.env.REACT_APP_APP_NAME || "CMS"
    return (
        <React.Fragment>
            <div className="vertical-menu">
                <div className="navbar-brand-box mt-3">
                    <Link to="/" className="logo logo-dark">
                        <span className="logo-sm ">
                            <img src={logoSm} alt="" height="22" style={{display: 'block', marginBottom: '2px'}} />
                        </span>
                        <span className="logo-lg ">
                            <img src={logoDark} alt="" height="17" style={{display: 'block', marginBottom: '2px'}} />
                        </span>
                    </Link>

                    <Link to="/" className="logo logo-light">
                        <span className="logo-sm ">
                            <img src={logoSm} alt="" height="22" style={{display: 'block',  marginBottom: '2px'}} />
                        </span>
                        <span className="logo-lg ">
                            <img src={logoLightPng} alt="" height="19" style={{display: 'block', marginBottom: '2px'}} />
                        </span>
                    </Link>
                </div>
                <div data-simplebar className="h-100">
                    <SidebarContent {...props} />
                </div>
                <div className="sidebar-background"></div>
            </div>
        </React.Fragment>
    )
}

Sidebar.propTypes = {
    type: PropTypes.string,
}

const mapStatetoProps = state => {
    return {
        layout: state.Layout,
    }
}
export default connect(
    mapStatetoProps,
    {}
)(withRouter((Sidebar)))
